

const Index = () => import(/* webpackChunkName: "customer" */ './index.vue');
const List = () => import(/* webpackChunkName: "customer" */ './view/CustomerList.vue');
const DeletedList = () => import(/* webpackChunkName: "customer" */ './view/DeletedCustomerList.vue');
const WithNoInvoice = () => import(/* webpackChunkName: "customer" */ '@/modules/Customer/components/CustomerWithInvoice.vue');
const WithNoSub = () => import(/* webpackChunkName: "customer" */ '@/modules/Customer/components/CustomerWithoutSubscription.vue');
const Profile = () => import(/* webpackChunkName: "customer" */ './view/Profile.vue');
// const Home = () => import(/* webpackChunkName: "customer" */ './view/Home.vue');



let routes = [];
// routes = routes.concat(PaymentRoutes);

routes = routes.concat([{
    path: 'list',
    name: 'payment-customer-list',
    component: List,
  },
  // {
  //   path: 'list',
  //   name: 'customer-list-payment',
  //   component: List,
  // },
  {
    path: 'deleted',
    name: 'deleted-customer-list',
    component: DeletedList,
  },
  {
    path: ':id/profile',
  name: 'customer-profile',
    component: Profile,
  },
  {
    path: 'noInvoice',
    name: 'with-out-invoice-list',
    component: WithNoInvoice,
  },
  {
    path: 'noSubscription',
    name: 'with-out-subscription-list',
    component: WithNoSub,
  },
]);

export default [{
  path: '/parents',
  redirect: { name: 'payment-customer-list' },
  component: Index,
  children: routes,
}];

